import { fetchBidderDataIfNeeded, getAuthToken, getBidderId } from './user';
import { deleteLAPaymentCard } from '@/redux/api/payment';
import { fetchLAPaymentCardIfNeeded } from './creditCard';
import { getDeployment } from './config';

const DELETE_LA_PAYMENT_CARD_FAIL = 'la/ui/deleteLAPaymentCard/FAIL';
const DELETE_LA_PAYMENT_CARD_REQUEST = 'la/ui/deleteLAPaymentCard/REQUEST';
const DELETE_LA_PAYMENT_CARD_SUCCESS = 'la/ui/deleteLAPaymentCard/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE & {
    errorMessage: string | null | undefined;
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DELETE_LA_PAYMENT_CARD_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: undefined,
                submitted: true,
                success: false,
            };
        case DELETE_LA_PAYMENT_CARD_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: undefined,
                submitted: false,
                success: true,
            };
        case DELETE_LA_PAYMENT_CARD_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: 'failed to delete card',
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */

/* ACTIONS CREATORS */
export const deleteCard = (cardId?: string) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const bidderId = getBidderId(state);
        const deployment = getDeployment(state);

        dispatch({
            type: DELETE_LA_PAYMENT_CARD_REQUEST,
        });

        const options = {
            authToken,
            bidderId,
            deployment,
        };

        await deleteLAPaymentCard({ ...options, cardId });

        await dispatch({
            meta: { actionTime: Date.now() },
            type: DELETE_LA_PAYMENT_CARD_SUCCESS,
        });

        dispatch(fetchBidderDataIfNeeded(authToken, true));
        dispatch(fetchLAPaymentCardIfNeeded());
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: DELETE_LA_PAYMENT_CARD_FAIL,
        });
    }
};
